import {resultChartOptions} from './chat-results.mjs';

const {useState,useRef} = React;

export function PanelPresentation({panel,artifact,lang,busy,onSave,onPreview}) {
  const he=lang==='he';
  const columns=panel.source.columns;
  const options=artifact?resultChartOptions(artifact):{categories:[],measures:[]};
  const initial=()=>({view:panel.presentation.view,chart_type:panel.presentation.chart_type||'bar',
    x:panel.presentation.x||options.x||columns[0],y:panel.presentation.y||options.y||columns[1],
    parent:panel.presentation.parent||columns[0],child:panel.presentation.child||columns[1]});
  const [draft,setDraft]=useState(initial);
  const disclosure=useRef(null);
  const categories=[...new Set([draft.x,...(options.categories.length?options.categories:columns)].filter(column=>columns.includes(column)))];
  const measures=[...new Set([draft.y,...(options.measures.length?options.measures:columns)].filter(column=>columns.includes(column)))];
  const keys=draft.view==='chart'?['x','y']:draft.view==='tree'?['parent','child']:[];
  const valid=keys.every(key=>columns.includes(draft[key]))&&(!keys.length||draft[keys[0]]!==draft[keys[1]]);
  const presentation=value=>({view:value.view,chart_type:value.chart_type,...(value.view==='chart'?{x:value.x,y:value.y}
    :value.view==='tree'?{parent:value.parent,child:value.child}:{})});
  const close=()=>{setDraft(initial());onPreview(null);disclosure.current.open=false;};
  const save=event=>{
    event.preventDefault();
    if(busy||!valid)return;
    onSave(presentation(draft));
    disclosure.current.open=false;
  };
  const select=(key,label,choices)=> <div className="data-dashboard-field"><label htmlFor={`${panel.id}-${key}`}>{label}</label><select id={`${panel.id}-${key}`} className="input" value={draft[key]||''} disabled={busy} onChange={event=>{
    const next={...draft,[key]:event.target.value};setDraft(next);
    const references=next.view==='chart'?['x','y']:next.view==='tree'?['parent','child']:[];
    if(references.every(reference=>columns.includes(next[reference]))&&(!references.length||next[references[0]]!==next[references[1]]))onPreview(presentation(next));
  }}>
    {choices.map(choice=><option key={choice.value||choice} value={choice.value||choice}>{choice.label||choice}</option>)}
  </select></div>;
  return <details className="data-dashboard-chart-settings" ref={disclosure}>
    <summary onClick={()=>{setDraft(initial());onPreview(null);}}>{he?'הגדרות תרשים':'Chart settings'}</summary>
    <form className="data-dashboard-presentation" onSubmit={save}>
      {select('view',he?'תצוגה':'View',[{value:'table',label:he?'טבלה':'Table'},{value:'chart',label:he?'תרשים':'Chart'},{value:'tree',label:he?'עץ':'Tree'}])}
      {draft.view==='chart'&&<>
        {select('chart_type',he?'סוג תרשים':'Chart type',[{value:'bar',label:he?'עמודות':'Bar'},{value:'line',label:he?'קווי':'Line'},{value:'doughnut',label:he?'טבעת':'Doughnut'}])}
        {select('x',he?'קטגוריה':'Category',categories)}
        {select('y',he?'מדד':'Measure',measures)}
      </>}
      {draft.view==='tree'&&<>
        {select('parent',he?'הורה':'Parent',columns)}
        {select('child',he?'ילד':'Child',columns)}
      </>}
      {!valid&&<p className="query-result-limit" role="status">{he?'בחרו שתי עמודות שונות.':'Choose two different columns.'}</p>}
      <div className="data-dashboard-presentation-actions">
        <button type="submit" className="btn btn-sm primary" disabled={busy||!valid}>{he?'שמירת תרשים':'Save chart'}</button>
        <button type="button" className="btn btn-sm" disabled={busy} onClick={close}>{he?'ביטול':'Cancel'}</button>
      </div>
    </form>
  </details>;
}
